import { IconButton } from '@mui/material';
import React from 'react';

export function CustomIconButton({ children, ...props }: any) {
    return <IconButton {...props}>{children}</IconButton>;
}
